import { Tooltip } from "@mui/material";

import noCdmIcon from "assets/images/cdm/empty-cdm.svg";
import { Button } from "components/ui/Button";

import style from "./NoCdmSection.module.css";

const PROGRAM_TYPE_MAPPING = {
  NOT_ENROLLED: "Not enrolled in programme ",
  PREVENTION_PROGRAMME: "Prevention programme",
  CHRONIC_DISEASE_MANAGEMENT: "Chronic disease management programme",
  DEREGISTERED: "Deregistered",
};

export const NoCdmSection = ({
  onAddCdmButtonClick,
  cdmStatus,
  options,
  isAddDisabled = false,
  addDisabledReason = "",
}) => {
  const getProgramTitle = (programType) => {
    return PROGRAM_TYPE_MAPPING[programType] || programType;
  };

  return (
    <section className={style.emptyState}>
      <img className={style.element} alt="Element" src={noCdmIcon} />
      <div className={style.text}>
        {cdmStatus?.currentProgramme ? (
          <div style={{ marginBottom: "24px" }} className={style.div}>
            <h3 className={style.textWrapper}>
              {getProgramTitle(cdmStatus.currentProgramme)}
            </h3>
            {!!cdmStatus.humanReadableSummary && (
              <p className={style.onceThePatient}>
                {cdmStatus.humanReadableSummary}
              </p>
            )}
          </div>
        ) : (
          <div className={style.div}>
            <div className={style.textWrapper}>
              No Chronic Disease Record selected
            </div>
            <p className={style.onceThePatient}>
              Select a chronic disease record or start a new consultation.
            </p>
          </div>
        )}
        {options.length > 0 && (
          <Tooltip title={isAddDisabled ? addDisabledReason : ""}>
            <span>
              <Button
                variant="primary"
                disabled={isAddDisabled}
                onClick={onAddCdmButtonClick}
              >
                Start review
              </Button>
            </span>
          </Tooltip>
        )}
      </div>
    </section>
  );
};
